export enum PressureUnits {
  Bar,
  Psi,
  Atm,
  Kpa,
  Ksi,
  Mpa
}
